class MediaGridCarousel extends HTMLElement {
  constructor() {
    super();
    this.mediaGridEl = null;
    this.swiper = null;
    this.speed = 0;
  }

  connectedCallback() {
    this.mediaGridEl = this.querySelector('.media-grid--carousel');
    if (!this.mediaGridEl) {
      console.warn('MediaGridCarousel: .media-grid--carousel element not found.');
      return;
    }

    this.speed = Number(this.mediaGridEl.getAttribute('data-carousel-speed')) || 0;

    this.swiper = new Swiper('.swiper', {
      loop: true,
      slidesPerView: 'auto',
      autoplay: {
        delay: this.speed,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  disconnectedCallback() {

  }
}

if (customElements && !customElements.get('media-grid-carousel')) {
  customElements.define('media-grid-carousel', MediaGridCarousel);
}
